import React, { useContext } from "react";
import { useModal } from "../Modals/ModaleContext";
import { FaWhatsapp } from "react-icons/fa";
import {
  FaBuilding,
  FaMoneyBill,
  FaClock,
  FaBed,
  FaBath,
  FaVectorSquare,
  FaArrowRight,
  FaPhoneAlt,
  FaEnvelope,
  FaShareAlt,
  FaMapMarkedAlt,
} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFire, faStar, faTags, faCrown } from "@fortawesome/free-solid-svg-icons";
import { useTranslateKey } from "../translation/useTranslateKey";
import { LangContext } from "../translation/langugeContext";

function PropertyCard({ property, projects, customClass }) {
  const { openModal } = useModal();
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);

  const handlePhoneClick = (e) => {
    if (isMobileDevice()) return;
    e.preventDefault();
    openModal("connection", { show: true, isEmail: false });
  };

  const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };

  const handleEmailClick = (e) => {
    if (isMobileDevice()) return;
    e.preventDefault();
    openModal("connection", {
      show: true,
      isEmail: true,
    });
  };

  return (
    <div
      key={property.id}
      className="grid property-card bg-white/10 backdrop-blur-lg rounded-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300 relative"
    >
      <div className="relative">
        <img
          src={`${property.images[0].image}`}
          alt={lang === "ar" ? property.title_ar : property.title}
          className="w-full h-64 object-cover"
        />
        <div className={`flags-container${lang === "ar" ? " flags-container-ar" : ""} ${customClass}`}
        dir={lang === "ar" ? "rtl" : "ltr"}>
          {property.is_hot_deal && (
            <div className="label-tag hot-offer-tag flex items-center gap-2 whitespace-nowrap bg-gradient-to-r from-red-600 to-red-800 text-white px-2 py-1 rounded-lg  text-sm">
              <FontAwesomeIcon icon={faFire} />
              <span className="label-text">{t("hotOfferLabel")}</span>
            </div>
          )}

            {property.luxury && (
            <div className="label-tag luxury-tag flex items-center gap-2 whitespace-nowrap bg-gradient-to-r from-yellow-600 to-yellow-800 text-white px-2 py-1 rounded-lg text-sm">
              <FontAwesomeIcon icon={faCrown} />
              <span className="label-text">{t("luxury1")}</span>
            </div>
          )}

          {property.featured && (
            <div className="label-tag featured-tag flex items-center gap-2 whitespace-nowrap bg-gradient-to-r from-yellow-600 to-yellow-800 text-white px-2 py-1 rounded-lg text-sm">
              <FontAwesomeIcon icon={faStar} />
              <span className="label-text">{t("featured1")}</span>
            </div>
          )}

          {property.is_price_reduced && (
            <div className="label-tag price-reduced-tag flex items-center gap-2 whitespace-nowrap bg-gradient-to-r from-blue-600 to-blue-800 text-white px-2 py-1 rounded-lg text-sm">
              <FontAwesomeIcon icon={faTags} />
              <span className="label-text">{t("Reduced")}</span>
            </div>
          )}
        </div>
      </div>

      <div className="p-6">
        <div className="project-location-container">
          <div className="flex items-center gap-2 mb-2 pl-1">
            <FaMapMarkedAlt className="text-[#F9C835]" />
            <span className="text-gray-300 text-sm">
              {t("locationLabel")}
               { lang === "ar" ? property.location_area.name_ar + " , " + property.location_area.city.name_ar
               :property.location_area.name_en + " , " + property.location_area.city.name_en}
            </span>
          </div>

          {property.project &&
            projects.find((proj) => proj.id === property.project) && (
              <div className="flex items-center gap-2 mb-3 pl-1">
                <FaBuilding className="text-[#F9C835]" />
                <span className="text-gray-300 text-sm">
                  {t("projectLabel")}
                  {lang === "ar" ? projects.find((proj) => proj.id === property.project).name_ar
                  : projects.find((proj) => proj.id === property.project).name}
                </span>
              </div>
            )}
        </div>
        <div className="card-description overflow-hidden">
          <h3 className="text-xl font-bold text-white mb-2">
            {lang === "ar" ?property.title_ar : property.title}
          </h3>
        </div>

        {/* Payment Details Section */}
        <div className="bg-white/5 rounded-xl pt-2" style={{ height: "187px" }}>
          <div className="payment-detail-item-container">
            {/* Old Price */}
            <div className="payment-detail-item">
              {property.display_original_price && (
                <>
                  <div className="text-gray-400 text-sm">{t("oldPriceLabel")}</div>
                  <div
                    className="text-base font-bold line-through"
                    style={{
                      color: "white !important",
                      textDecorationColor: "#FF0000",
                    }}
                  >
                    {Number(property.display_original_price).toLocaleString("en-US")} {property.display_currency}
                  </div>
                </>
              )}
            </div>

            {/* Payment Type Toggle */}
            <div className="payment-detail-item">
              <div className="bg-[#11132F]/50 backdrop-blur-lg rounded-lg flex items-center p-1">
                <div className="flex items-center">
                  {property.payment_plan === "cash" ? (
                    <label
                      htmlFor={`cashPayment-${property.id}`}
                      className="cash-installment-lable cursor-pointer pl-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2 transition-all duration-300 primary-active"
                    >
                      <FaMoneyBill />
                      {t("cash")}
                    </label>
                  ) : (
                    <label
                      htmlFor={`installmentPayment-${property.id}`}
                      className="cash-installment-lable cursor-pointer pl-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2 transition-all duration-300 primary-active "
                    >
                      <FaClock />
                      {t("installments")}
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Current Prices */}
            <div className="payment-detail-item">
              <div className="text-gray-400 text-sm">{t("totalPriceLabel")}</div>
              <div className="text-xl font-bold text-[#FF0000]">
                {Number(property.display_price).toLocaleString("en-US")}{" "}
                {property.display_currency}
              </div>
            </div>
            <div className="payment-detail-item justify-end pl-3">
              {property.display_down_payment && (
                <div className="p-1">
                  <div className="text-gray-400 text-sm">{t("downPaymentLabel")}</div>
                  <div className="text-lg font-bold text-[#FF0000]">
                    {Number(property.display_down_payment).toLocaleString("en-US")}
                  </div>
                  <div className="text-xs text-[#F9C835]">
                    ({Math.round(property.down_payment_percentage)}%)
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Property Features */}
        <div className="propert-features-container">
          <div className="feature-item flex flex-col items-center text-center bg-white/5 p-2 rounded-xl">
            <FaBed className="text-[#F9C835] text-lg mb-1" />
            <div className="flex flex-col">
              <span className="text-lg font-bold text-white">
                {property.bedrooms}
              </span>
              <span className="text-xs text-gray-300">{t("bedroomsLabel")}</span>
            </div>
          </div>
          <div className="feature-item flex flex-col items-center text-center bg-white/5 p-2 rounded-xl">
            <FaBath className="text-[#F9C835] text-lg mb-1" />
            <div className="flex flex-col">
              <span className="text-lg font-bold text-white">
                {property.bathrooms}
              </span>
              <span className="text-xs text-gray-300">{t("bathroomsLabel")}</span>
            </div>
          </div>
          <div className="feature-item flex flex-col items-center text-center bg-white/5 p-2 rounded-xl">
            <FaVectorSquare className="text-[#F9C835] text-lg mb-1" />
            <div className="flex flex-col">
              <span className="text-lg font-bold text-white">
                {property.area}
              </span>
              <span className="text-xs text-gray-300">
                {t("areaUnit")}
              </span>
            </div>
          </div>
        </div>

        {/* View Details Button */}
        <a
          href={`property-details/${property.id}`}
          className="view-details-btn mb-4 flex items-center gap-2 text-[#F9C835] hover:text-white transition-colors"
        >
          {t("viewDetailsLabel")}
          <FaArrowRight className="arrow-icon" />
        </a>

        {/* Social Media Share Buttons */}
        <div className="flex justify-end gap-2">
          <a
            href="https://wa.me/+201030282513"
            target="_blank"
            rel="noopener noreferrer"
            className=" social-button w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-[#25D366] text-white rounded-full transition-colors duration-300"
          >
            <FaWhatsapp className=" text-sm social-icon " />
          </a>

          <a
            href="tel:+201030282513"
            onClick={handlePhoneClick}
            className="social-button w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-[#FF6B6B] text-white rounded-full transition-colors duration-300"
          >
            <FaPhoneAlt className="text-sm social-icon" />
          </a>

          <a
            href="mailto:info@ssignature.com"
            onClick={handleEmailClick}
            className=" social-button w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-[#EA4335] text-white rounded-full transition-colors duration-300"
          >
            <FaEnvelope className="text-sm social-icon" />
          </a>

          <a
            onClick={() =>
              openModal("share", {
                show: true,
                propertyId: property.id,
                propertyTitle: property.title,
              })
            }
            className="social-button w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-[#4CAF50] text-white rounded-full transition-colors duration-300"
            aria-label={t("share")}
          >
            <FaShareAlt className="text-sm social-icon" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default PropertyCard;
